import { Injectable } from '@angular/core';
import { RequestOptions, URLSearchParams } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppSettings } from './../app.settings';
import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';
import { CommonRequestTableService } from './common-table-request.service';
import { CommonGfoService } from './common-gfo.service';
import { SubsUser } from './user-management.service';
import { FeatureToggleService } from './feature-toggle.service';
import { ToastrService } from 'ngx-toastr';

export interface LBSubscription {
	subId: number; // subscription id
	appName: string;
	subLevel: string; // eg. 'TRIAL'
	subAuthType: string; // eg. 'LB MANAGED'
	startDate: any;
	expireDate: string;
	mostRecent: boolean; // current sub or most recently expired sub
	state: 'current' | 'future' | 'expired' | null; // Sub is current, expired or for future use. // null means the app is not subscribed.
	term: any; // eg. 365
	locked: boolean; // ??
}
export interface UserSubscription {
	userId: number;
	userSubId: number;
	role: string; // eg. 'OPERATOR',
	userEmail: string;
	cusNameShort: string;
	cusEmail: string;
	userSsoName: string; // ???
	appName: string;
	subId: number;
	subLevel: string; // eg. 'STARTER',
	subAuthType: string; // eg. 'LB MANAGED',
}
// export interface UserRoleFormat {
// 	roleId: number;
// 	roleName: string;
// 	userSubId: number;
// 	email: string;
// 	app: string;
// }
export interface GisticUser {
	userId: number;
	email: string;
	isAdmin: boolean;
	isSA: boolean;
}
export interface UserGet {
	email: string;
	id: number;
	cusNameShort: string;
	cusId: number;
}

@Injectable()
export class AdminService {

	// Subscriptions under the current customer
	// This is updated inside getSubscriptions
	public subscriptions: BehaviorSubject<LBSubscription[]> = new BehaviorSubject(null);
	// User subscriptions of all applications
	public userSubscriptions: UserSubscription[];

	private userRoles: any[] = [
		{
			name: 'Admin',
			value: 'admin'
		}, {
			name: 'Editor',
			value: 'editor'
		}, {
			name: 'Viewer',
			value: 'viewer'
		}

	];
	private users: any[] = [
		{
			name: 'user1',
			email: 'user1@gmail.com',
			role: 'editor'
		}, {
			name: 'user2',
			email: 'user2@gmail.com',
			role: 'viewer'
		}
	];
	constructor(
		private toastr: ToastrService,
		private ftService: FeatureToggleService,
		private userService: UserService,
		private requestService: CommonRequestService,
		private tableRequestService: CommonRequestTableService,
		private gfoService: CommonGfoService
	) { }

	// Check if the customer has subscription of an app
	checkHasSub(appName: string): boolean {
		const currSubs = this.subscriptions.getValue();
		const hasSub = currSubs.some((s) => {
			return s.appName === appName && (!!s.state && s.state !== 'expired'); // ??? can expired sub show?
		});
		return hasSub;
	}

	getUserRoles() {
		return this.userRoles;
	}

	getSubscriptions(appName?: string, customerId?: number, skipUpdate?: boolean) {
		return new Promise<LBSubscription[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/subscription';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			customerId = customerId || this.userService.getUserInfo().customerId;
			params.set('customerId', JSON.stringify(customerId));
			if (appName) {
				params.set('application', appName);
			}
			options.params = params;
			this.requestService.requestGet(url, options,
				async (rsp) => {
					const subs = this.transformSubscriptions(rsp.data).filter((s) => s.mostRecent).sort((a, b) => {
						if (a.state === 'current') {
							return -1;
						} else {
							return 1;
						}
					});
					if (!skipUpdate) {
						// Update feature toggle
						await this.ftService.updateFeatureToggle();
						// Update subscriptions
						this.subscriptions.next(subs);
					}
					resolve(subs);
				}, (err) => {
					console.log(err);
					resolve([]);
				});
		});
	}
	transformSubscriptions(data: any[]): LBSubscription[] {
		const subscriptions: LBSubscription[] = [];
		data.forEach((item) => {
			subscriptions.push({
				subId: item.sub_id,
				appName: item.sub_mod_cd,
				startDate: item.sub_start,
				expireDate: item.expire_date,
				state: item.sub_state,
				mostRecent: item.most_recent,
				term: item.sub_term,
				locked: item.sub_locked,
				subLevel: item.sub_cgs_sub_level,
				subAuthType: item.sub_cgs_auth_type
			});
		});
		return subscriptions;
	}
	// Add Subscription to current customer
	// if oldSubId is passed, the newly added subscription will extend to child agency that relates to old sub (for GIVE use)
	// TODO: Change Hard Code
	addSubscription(appName, subLevel, startDate?, term?, customerId?, adminId?, oldSubId?) {
		return new Promise<{subId;}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/subscription';
			customerId = customerId || this.userService.getUserInfo().customerId;
			adminId = adminId || this.userService.getUserInfo().userId;
			const body: any = {
				customerId: customerId,
				application: appName,
				level: subLevel, // level of sub, basic/professional.... // 1019, // trial
				authType: 'LB MANAGED', // 1018, // LB Managed
				adminId: adminId
			};
			if (startDate) {
				body.startDate = startDate;
			}
			if (term) {
				body.term = term; // days of subscribtion
			}
			if (oldSubId) {
				body.oldSubscriptionId = oldSubId;
			}
			this.requestService.requestPost(url, body, rsp => {
				if (rsp.data[0]) {
					resolve({
						subId: rsp.data[0].sub_id
					});
				} else {
					resolve(null);
				}
			}, err => reject(err), true);
		});
	}
		// TODO: delete
		addSubscription_(appName, subLevel, startDate?, term?, successCallback?, errorCallback?, customerId?, adminId?) {
			return new Promise<{subId;}>((resolve, reject) => {
				const url = AppSettings.serviceRootUrl + 'admin/subscription';
				customerId = customerId || this.userService.getUserInfo().customerId;
				adminId = adminId || this.userService.getUserInfo().userId;
				const body: any = {
					customerId: customerId,
					application: appName,
					level: subLevel, // level of sub, basic/professional.... // 1019, // trial
					authType: 'LB MANAGED', // 1018, // LB Managed
					adminId: adminId
				};
				if (startDate) {
					body.startDate = startDate;
				}
				if (term) {
					body.term = term; // days of subscribtion
				}
				return this.requestService.requestPost(url, body, rsp => {
					if (rsp.data[0]) {
						resolve({
							subId: rsp.data[0].sub_id
						});
					} else {
						resolve(null);
					}
					if (successCallback) {
						successCallback(rsp);
					}
				}, err => {
					reject(err);
					if (errorCallback) {
						errorCallback(err);
					}
				}, true);
			});
		}
	// Remove subscription
	deleteSubscription(subId, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'admin/subscription';
		const body = {
			adminId: this.userService.getUserInfo().userId,
			subscriptionId: subId
		};
		const options = new RequestOptions({
			body: body
		});
		return this.requestService.requestDelete(url, options, successCallback, errorCallback);
	}
	// Cancel subscription
	// Put method
	cancelSubscription(subId) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/subscription';
			const dateStr = new Date().toDateString();
			const body = {
				subscriptionId: subId,
				endDate: dateStr
			};
			this.requestService.requestPut(url, body, rsp => resolve(rsp), err => reject(err));
		});
	}
	// Update subscription
	async updateSubscription(subId, appName: string, subLevel: string, startDate, term: number, oldSubId?) {
		// Cancel sub then add new sub
		try {
			await this.cancelSubscription(subId);
		} catch (err) {
			this.toastr.error('Failed to update endDate');
			throw err;
		}
		const rsp = await this.addSubscription(appName, subLevel, startDate, term, null, null, oldSubId);
		return rsp;
	}

	getUsers(customerId?: number) {
		return new Promise<SubsUser[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/userList';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			customerId = customerId || this.userService.getUserInfo().customerId;
			params.set('customerId', JSON.stringify(customerId));
			options.params = params;
			this.requestService.requestGet(url, options,
				(rsp) => {
					const users: SubsUser[] = [];
					if (rsp.data) {
						rsp.data.forEach((item) => {
							const user: SubsUser = {
								userEmail: item.usr_email,
								userName: item.usr_name,
								userId: item.usr_id,
								userSubs: {},
								isAdmin: item.usr_agency_owner_flag, // item.usr_admin_flag,
								signupState: item.usr_signup_state
							};
							if (item.subs) {
								item.subs.forEach((sub) => {
									user.userSubs[sub] = true;
								});
							}
							users.push(user);
						});
					}
					resolve(users);
				}, err => reject(err));
		});
	}
	transformUsers(data: any[]) {

	}
	addUser(email, customerId?, adminId?, isAdmin?: boolean, userName?: string) {
		return new Promise<any>((resolve, reject) => {
			customerId = customerId || this.userService.getUserInfo().customerId;
			if (!adminId && adminId !== 0) {
				adminId = this.userService.getUserInfo().userId;
			}
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const body: any = {
				email: email,
				customerId: customerId,
				adminId: adminId,
				isAdmin: isAdmin
			};
			if (userName) {
				body.userName = userName;
			}
			this.requestService.requestPost(url, body, (rsp) => {
				resolve(rsp);
			}, err => reject(err));
		});
	}
	deleteUser(email, customerId?: number) {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			customerId = customerId || this.userService.getUserInfo().customerId;
			const body = {
				email: email,
				adminId: this.userService.getUserInfo().userId,
				customerId: customerId
			};
			const options = new RequestOptions({
				body: body
			});
			return this.requestService.requestDelete(url, options, rsp => resolve(rsp), err => reject(err));
		});
	}
	getUser(email: string, notAuthenticated?: boolean) {
		return new Promise<UserGet>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const options = new RequestOptions();
			const params = new URLSearchParams();
			params.set('email', email);
			options.params = params;
			this.requestService.requestGet(url, options, rsp => {
				if (rsp && rsp.data && rsp.data[0]) {
					const data = rsp.data[0];
					resolve({
						email: data.usr_email,
						id: data.usr_id,
						cusNameShort: data.cus_name_short,
						cusId: data.cus_id
					});
				} else {
					resolve(null);
				}
			}, err => reject(err), notAuthenticated)
		})
	}

	getUserSubscriptions(
		email?: string,
		application?: string,
		isUpdateUserSubs?: boolean,
		customerId?: number,
		successCallback?: (a: UserSubscription[]) => any,
		errorCallback?
	): Promise<UserSubscription[]> {
		const url = AppSettings.serviceRootUrl + 'admin/userSubscription';
		const params = new URLSearchParams();
		const options = new RequestOptions();
		if (email) {
			// email = this.userService.getUserInfo().userEmail;
			params.set('email', email);
		}
		if (application) {
			params.set('application', application);
		}
		customerId = customerId || this.userService.getUserInfo().customerId;
		params.set('customerId', JSON.stringify(customerId));
		options.params = params;
		return new Promise((resolve, reject) => {
			this.requestService.requestGet(url, options,
				(rsp) => {
					const userSubs = this.transformUserSubs(rsp.data);
					resolve(userSubs);
					if (isUpdateUserSubs) {
						this.userSubscriptions = userSubs;
					}
					if (successCallback) {
						successCallback(userSubs);
					}
				}, (err) => {
					if (errorCallback) { errorCallback(); }
					reject();
				}); // TODO: ?? true
		});
	}
	transformUserSubs(data: any[]): UserSubscription[] {
		const userSubs: UserSubscription[] = [];
		data.forEach((item) => {
			userSubs.push({
				userId: item.usr_id,
				userSubId: item.usb_id,
				role: item.rol_cgs_role, // eg. 'OPERATOR',
				userEmail: item.usr_email,
				cusNameShort: item.cus_name_short,
				cusEmail: item.cus_email,
				userSsoName: item.usr_sso_name,
				appName: item.sub_mod_cd,
				subId: item.sub_id,
				subLevel: item.sub_cgs_sub_level, // eg. 'STARTER',
				subAuthType: item.sub_cgs_auth_type // eg. 'LB MANAGED',
			});
		});
		return userSubs;
	}
	getPortalUserSubscription(): Promise<UserSubscription> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/userSubscription';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('email', this.userService.getUserInfo().userEmail);
			params.set('application', AppSettings.appName);
			params.set('customerId', JSON.stringify(this.userService.getUserInfo().customerId));
			params.set('portal', 'true');
			options.params = params;
			this.requestService.requestGet(url, options,
				(rsp) => {
					const userSubs = this.transformUserSubs(rsp.data);
					resolve(userSubs[0]);
				}, (err) => {
					reject();
				}); // TODO: ?? true
		});
	}

	// Add Subscription to a user under the current customer
	// userId is the id of user the subscription will be added to
	addUserSubscription(userId, subscriptionId, roleId?, adminId?) {
		return new Promise<{usbId;}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/userSubscription';
			adminId = adminId || this.userService.getUserInfo().userId; // user has to be admin to call this service
			const body = {
				userId: userId,
				subscriptionId: subscriptionId,
				adminId: adminId
			};
			if (roleId || roleId === 0) {
				body['roleId'] = roleId;
			}
			return this.requestService.requestPost(url, body, rsp => {
				if (rsp.data && rsp.data.result[0]) {
					resolve({
						usbId: rsp.data.result[0].usb_id
					});
				} else {
					resolve(null);
				}
			}, err => reject(err), true);
		});
	}
	addUserSubscriptions(userId, subIds: any[], successCallback?, errorCallback?) {
		const promises = [];
		subIds.forEach((id) => {
			const promise = new Promise(async(resolve, reject) => {
				try {
					const rsp = await this.addUserSubscription(userId, id);
					resolve(rsp);
				} catch (err) {
					reject(err);
				}
			});
			promises.push(promise);
		});
		Promise.all(promises)
		.then((rsp) => {
			if (successCallback) {
				successCallback(rsp);
			}
		})
		.catch((err) => {
			if (errorCallback) {
				errorCallback();
			}
		});
	}

	removeUserSubscription(userSubId) {
		return new Promise<void>((resolve, reject) => {
			const body = {
				userSubscriptionId: userSubId,
				adminId: this.userService.getUserInfo().userId
			};
			const options = new RequestOptions({
				body: body
			});
			return this.requestService.requestDelete(AppSettings.serviceRootUrl + 'admin/userSubscription', options, rsp => {
				resolve();
			}, err => reject(err));
		});
	}

	updateUserSubscription(usbId, roleId): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/userSubscription';
			const body = {
				userSubscriptionId: usbId,
				roleId: roleId
			};
			this.requestService.requestPut(url, body, () => {
				resolve();
			}, (err) => {
				reject(err);
			});
		});
	}

	// Add or remove the site-admin property for user
	updateUserSiteAdmin(isSiteAdmin: boolean, userEmail: string) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const bodyUpdate = {
				email: userEmail,
				isSiteAdmin: isSiteAdmin
			};
			this.requestService.requestPut(url, bodyUpdate, (rsp) => {
				resolve();
			}, (err) => {
				reject(err);
			}, true);
		});
	}
	// Add or remove the site-admin property for user
	updateUserAdmin(isAdmin: boolean, userEmail: string) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/user';
			const bodyUpdate = {
				email: userEmail,
				isAdmin: isAdmin
			};
			this.requestService.requestPut(url, bodyUpdate, (rsp) => {
				resolve();
			}, (err) => {
				reject(err);
			}, true);
		});
	}
	getGisticUsers() {
		return new Promise<GisticUser[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/userListGistic';
			this.requestService.requestGet(url, null, (rsp) => {
				const users: GisticUser[] = [];
				if (rsp && rsp.data) {
					rsp.data.forEach((d) => {
						users.push({
							userId: d.usr_id,
							email: d.usr_email,
							isAdmin: d.usr_agency_owner_flag, // d.usr_admin_flag,
							isSA: d.usr_site_admin_flag, // d.usr_sa_flag
						});
					})
				}
				resolve(users);
			}, err => reject(err))
		})
	}

	// E.g. for azgiv updating customer givState
	updateCustomerConfig(param, value, customerId?) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/customerConfig';
			const body = {
				customerId: customerId || this.userService.getUserInfo().customerId,
				param: param,
				value: value
			};
			this.requestService.requestPut(url, body, rsp => {
				resolve();
			}, err => reject(err));
		});
	}
	insertCustomerConfig(param, value, customerId?) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/customerConfig';
			const body = {
				customerId: customerId || this.userService.getUserInfo().customerId,
				param: param,
				value: value
			};
			this.requestService.requestPost(url, body, rsp => {
				resolve();
			}, err => reject(err));
		});
	}

	generateApiKey(email, pw, permissions) {
		return new Promise<string>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/apiKey';
			const body: any = {
				email: email,
				password: pw,
				permissions: JSON.stringify(permissions)
			};
			this.requestService.requestPost(url, body, (rsp) => resolve(rsp.data.content), (err) => reject(err));
		});
	}


	isStateAgencyInitialized() {
		return new Promise<{val: '-1' | '0' | '1'; msg?: string}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/isStateAgencyInitialized';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('userId', this.userService.getUserInfo().userId.toString());
			options.params = params;
			this.requestService.requestGet(url, options,
				async (rsp) => {
					resolve(rsp.data);
				}, err => reject(err));
		});
	}
	initializeStateLayer() {
		return new Promise<{subId;}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/initializeStateLayer';
			const body: any = {
				userId: this.userService.getUserInfo().userId
				// stateCode: stateCode,
				// userSubscriptionId: usbId
			};
			return this.requestService.requestPost(url, body, rsp => {
				resolve(rsp)
			}, err => {
				reject(err);
			});
		});
	}
	async getCustomerSummary(customerId?: number) {
		return new Promise<any>((resolve, reject) => {
			const params = new URLSearchParams();
			const options = new RequestOptions();
			if(customerId) {
				params.set('customerId', customerId.toString());
			}
			options.params = params;
			this.requestService.requestGet(AppSettings.serviceRootUrl + 'azgiv/summaryCustomers', options,
				rsp => {
					const list = [];
					if (rsp.data) {
						rsp.data.forEach(i => {
							list.push({
								cusId: i.cus_id,
								name: i.cus_name_short,
								children: i.cus_ids_child ? i.cus_ids_child : [],
								level: i.level,
								layerCount: i.layer_cnt,
								userCount: i.user_cnt,
								childAgencyCount: i.child_agency_cnt,
								giveSubState: i.give_sub_state,
								giveExpire: i.give_expire_date,
								a3iSubState: i.a3i_sub_state,
								a3iExpire: i.a3i_expire_date,
								tranxLockCount: i.tranx_lock_cnt,
								tranxCount: i.tranx_cnt,
								ownerEmails: i.admin_emails
							});
						});
					}
					resolve(list);
				},
				err => reject(err)
			);
		});
	}
	async getLayerSummary(customerId?: number) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/summaryLayers';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('customerId', customerId.toString());
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				const layers: any[] = [];
				if (rsp.data) {
					rsp.data.forEach((l) => {
						layers.push({
							cusId: l.cus_id,
							layerId: l.gly_id,
							code: l.glt_cd,
							name: l.glt_name_short,
							maint: l.gly_maint_type,
							state: l.lol_state,
							collab: l.gtc_collaborative,
							loadTime: l.load_time,
							rowCount: l.row_count,
							score: l.qa_score
						});
					});
				}
				resolve(layers);
			}, (err) => {
				reject(err);
			});
		});
	}
	async getEndUserSummary(customerId?: number) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/summaryEndUsers';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('customerId', customerId.toString());
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				const users: any[] = [];
				if (rsp.data) {
					rsp.data.forEach((u) => {
						users.push({
							userId: u.usr_id,
							name: u.usr_name,
							cusId: u.cus_id,
							agencyOwner: u.usr_agency_owner_flag,
							role: u.usr_data_role,
							signupState: u.usr_signup_state,
							lastTranx: u.last_tranx_dt,
							subs: u.subs ? u.subs : []
						});
					});
				}
				resolve(users);
			}, (err) => {
				reject(err);
			});
		});
	}
	async getIntegratorUserSummary(customerId?: number) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/summaryIntegratorUsers';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			if(customerId) {
				params.set('customerId', customerId.toString());
			}
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				const users: any[] = [];
				if (rsp.data) {
					rsp.data.forEach((u) => {
						users.push({
							userId: u.usr_id,
							name: u.usr_name,
							cusId: u.cus_id,
							cusName: u.cus_name_short,
							userCusName: u.usr_cus_name_short,
							userCusId: u.usr_cus_id,
							agencyOwner: u.usr_agency_owner_flag,
							role: u.usr_data_role,
							signupState: u.usr_signup_state,
							lastTranx: u.last_tranx_dt
						});
					});
				}
				resolve(users);
			}, (err) => {
				reject(err);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/admin.service.ts